import React from 'react';
import CourseCardV2 from 'Components/CourseCardV2/CourseCardV2';
import FilterContainer from 'Containers/FilterContainer';
import LoadingContainer from 'Containers/LoadingContainer';
import type { DashboardCourseI } from 'types';
import type { MyCourseCardVM } from '../../../hooks/useMyCoursesPage';
import { DueText, ListMyCourses } from './CoursesCardGrid.styled';

export interface CoursesCardGridPropsI {
  items: MyCourseCardVM[];
  loading: boolean;
  emptyText: React.ReactNode;
  onCourseClick: (course: DashboardCourseI) => void;
}

/**
 * La tarjeta ya recibe `dueText`, pero aquí se prioriza la vigencia real del
 * curso para desacoplarla del texto legacy basado en `expirationDate`.
 */
const getCoursePeriodLabel = (course: DashboardCourseI): string | null => {
  if (!course.periodStartsAt) return null;
  if (!course.periodDueAt) return null;
  if (course.daysLeft === 0) return 'Último día para realizarlo';
  if (course.daysLeft === null) return `Vence el ${course.periodDueAt}`;
  return `Vence el ${course.periodDueAt} · ${course.daysLeft} días`;
};

const isUrgentPeriod = (course: DashboardCourseI): boolean => course.daysLeft !== null && course.daysLeft <= 3;

export default function CoursesCardGrid({ items, loading, emptyText, onCourseClick }: CoursesCardGridPropsI) {
  if (items.length === 0)
    return (
      <FilterContainer>
        <LoadingContainer isLoading={loading}>{emptyText}</LoadingContainer>
      </FilterContainer>
    );

  return (
    <FilterContainer>
      <ListMyCourses>
        {items.map(item => {
          const periodText = getCoursePeriodLabel(item.course);

          return (
            <CourseCardV2
              key={item.course.id}
              name={item.name}
              thumbnailUrl={item.thumbnailUrl}
              modulesText={item.modulesText}
              dueText={periodText ? <DueText urgent={isUrgentPeriod(item.course)}>{periodText}</DueText> : null}
              description={item.description}
              status={item.status}
              category={item.category}
              creator={item.creator}
              onClick={() => onCourseClick(item.course)}
            />
          );
        })}
      </ListMyCourses>
    </FilterContainer>
  );
}
